/**
 * @generated SignedSource<<e2f83290acf1e7a723b551b6cbc150e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AttributeConditionOperator = "EQUALS" | "EXISTS" | "%future added value";
export type MailingListType = "DYNAMIC" | "STATIC" | "%future added value";
export type SubscriptionStatusEnum = "SUBSCRIBED" | "UNSUBSCRIBED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MailingListDetailsView_mailingList$data = {
  readonly archivedAt: any | null | undefined;
  readonly createdAt: any;
  readonly criterion: {
    readonly conditions: ReadonlyArray<{
      readonly attributeName: string;
      readonly operator: AttributeConditionOperator;
      readonly value: string | null | undefined;
    }>;
  } | null | undefined;
  readonly description: string;
  readonly id: string;
  readonly mailingListIdentifier: string;
  readonly members: ReadonlyArray<{
    readonly contact: {
      readonly emailAddress?: string | null | undefined;
      readonly familyName?: string;
      readonly givenName?: string;
      readonly id: string;
      readonly teamName?: string;
    } | null | undefined;
    readonly contactIdentifier: string;
    readonly mailingListIdentifier: string;
    readonly status: SubscriptionStatusEnum;
    readonly subscribedAt: any;
    readonly unsubscribeReason: string | null | undefined;
    readonly unsubscribedAt: any | null | undefined;
  }>;
  readonly name: string;
  readonly subscribedCount: number;
  readonly subscriptionReason: {
    readonly de: string | null | undefined;
    readonly en: string | null | undefined;
  } | null | undefined;
  readonly type: MailingListType;
  readonly unsubscribedCount: number;
  readonly unsubscribedMembers: ReadonlyArray<{
    readonly contact: {
      readonly emailAddress?: string | null | undefined;
      readonly familyName?: string;
      readonly givenName?: string;
      readonly id: string;
      readonly teamName?: string;
    } | null | undefined;
    readonly contactIdentifier: string;
    readonly mailingListIdentifier: string;
    readonly status: SubscriptionStatusEnum;
    readonly subscribedAt: any;
    readonly unsubscribeReason: string | null | undefined;
    readonly unsubscribedAt: any | null | undefined;
  }>;
  readonly " $fragmentType": "MailingListDetailsView_mailingList";
};
export type MailingListDetailsView_mailingList$key = {
  readonly " $data"?: MailingListDetailsView_mailingList$data;
  readonly " $fragmentSpreads": FragmentRefs<"MailingListDetailsView_mailingList">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mailingListIdentifier",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contactIdentifier",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subscribedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unsubscribedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unsubscribeReason",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "contact",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "givenName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "familyName",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "type": "PersonContact",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamName",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "type": "TeamContact",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MailingListDetailsView_mailingList",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "subscriptionReason",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "de",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "en",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subscribedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unsubscribedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archivedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MembershipCriterion",
      "kind": "LinkedField",
      "name": "criterion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeCondition",
          "kind": "LinkedField",
          "name": "conditions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attributeName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "operator",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListMembership",
      "kind": "LinkedField",
      "name": "members",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListMembership",
      "kind": "LinkedField",
      "name": "unsubscribedMembers",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "type": "MailingList",
  "abstractKey": null
};
})();

(node as any).hash = "dcb0adbd874f9338a99f6a1bb7d69257";

export default node;
